export const en = {
    'changes-confirm': 'Changes will not be saved. Continue?',
    'no-phrases-for-dynamic-campaigns': 'You cannot add keywords to Dynamic campaign ad groups',
    'no-phrases-for-smart-banners':
        "You can't set up a deactivation threshold as there is no payer specified for your account. You can {addPayerLink} and set up the suspension threshold",
    'refine-phrases-error': 'An error occurred while loading keywords. Please try again.',
    'refine-phrases-shows-error': 'Failed to refine the impression forecast.',
    'start-phrases-error': 'An error occurred while loading keywords. Refresh the page and try again.'
};
